import { sanitizeInput } from '../../utils/xssProtection';

export default function SearchBox({
  value,                  // keyword
  onChange,               // setKeyword
  options,                // [{ value: '0', label: '전체' },…]
  selected,               // searchKind
  onSelect,               // setSearchKind
  onSearch,               // handleSearch
  onReset,                // handleReset
  suggestions = [],       // 추천 리스트
  onSuggestSelect,         // 추천 클릭 시
  onExcelDownload,         // 엑셀 다운로드
  onDelete,               // 삭제 함수
  deleteButtonConfig      // 삭제 버튼 설정 { label, count, style }
}) {
    const handleKeyup = (e) => {
        if(e.key === 'Enter') {
            onSearch();
        } 
    }
    
    const handleInputChange = (e) => {
        const rawValue = e.target.value;
        
        // XSS 방지를 위한 입력값 정화
        const sanitizedValue = sanitizeInput(rawValue);
        
        // 검색어 길이 제한 (너무 긴 검색어 방지)
        const maxLength = 100;
        const truncatedValue = sanitizedValue.length > maxLength 
            ? sanitizedValue.substring(0, maxLength) 
            : sanitizedValue;
        
        onChange(truncatedValue);
    };
    
    const handleSuggestionSelect = (suggestion) => {
        // 추천 검색어도 정화 처리
        const sanitizedSuggestion = sanitizeInput(suggestion);
        onSuggestSelect(sanitizedSuggestion);
    };
    
    const handleClick = () => {
        //onChange('');
    }
  return (
    <div className="left">
        <div className="select_box">
            <select value={selected} onChange={e => onSelect(e.target.value)}>
            {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
        </div>
        <div className="search_wrap insert-wrap">
            <div className="search">
                <div className="input">
                    <input
                        type="text"
                        value={value}
                        onChange={handleInputChange} // XSS 방지 처리된 입력 핸들러
                        onKeyUp={handleKeyup} // Handles Enter key for search
                        onClick={handleClick}
                        placeholder="검색어를 입력하세요"
                        maxLength="100"
                    />
                </div>
                <i onClick={onSearch}>
                    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg" id="searchButton">
                        <path d="M24.6582 21.6162L19.79 16.748C19.5703 16.5283 19.2725 16.4062 18.96 16.4062H18.1641C19.5117 14.6826 20.3125 12.5146 20.3125 10.1562C20.3125 4.5459 15.7666 0 10.1562 0C4.5459 0 0 4.5459 0 10.1562C0 15.7666 4.5459 20.3125 10.1562 20.3125C12.5146 20.3125 14.6826 19.5117 16.4062 18.1641V18.96C16.4062 19.2725 16.5283 19.5703 16.748 19.79L21.6162 24.6582C22.0752 25.1172 22.8174 25.1172 23.2715 24.6582L24.6533 23.2764C25.1123 22.8174 25.1123 22.0752 24.6582 21.6162ZM10.1562 16.4062C6.7041 16.4062 3.90625 13.6133 3.90625 10.1562C3.90625 6.7041 6.69922 3.90625 10.1562 3.90625C13.6084 3.90625 16.4062 6.69922 16.4062 10.1562C16.4062 13.6084 13.6133 16.4062 10.1562 16.4062Z" fill="#45A3FB"></path>
                    </svg>
                </i>
            </div>  
            <div className="search_list">
                <ul>
                {suggestions.map((s,i) => (
                    <li key={i} onClick={() => handleSuggestionSelect(s)}>{s}</li>
                ))}
                </ul>
            </div>
        </div>
        {onExcelDownload && (
            <div className="xlsx-wrap insert-wrap">
                <div className="insert insert-input-btn">
                    <input className="btn-xlsx" type="button" value="엑셀다운로드" onClick={onExcelDownload}/>
                </div>
            </div>
        )}
        {onDelete && deleteButtonConfig && (
            <div className="xlsx-wrap insert-wrap">
                <input type="button" 
                    className="btn btn-md primary mr-1" 
                    style={deleteButtonConfig.style || {backgroundColor: '#ff2b2b'}} 
                    value={`${deleteButtonConfig.label} ${deleteButtonConfig.count > 0 ? `(${deleteButtonConfig.count})` : ''}`}
                    onClick={onDelete} 
                />   
            </div> 
        )}
        <div className="insert-wrap">
            <button className="btn btn-md primary mr-1" onClick={onReset}>초기화</button>
        </div>
    </div>
  );
}